import React from 'react';
import Typography from '@material-ui/core/Typography';

export default class DescriptionList extends React.Component {
  renderListItems() {
    return this.props.data.items.map((val, i) => {
      return <li>{val}</li>;
    });
  }

  renderOrderedList() {
    return <ol>{this.renderListItems()}</ol>;
  }

  renderUnorderedList() {
    return <ul>{this.renderListItems()}</ul>;
  }

  render() {
    const { data } = this.props;

    return (
      <Typography variant="body1" gutterBottom>
        {data.preText}
        {
          data.type === 'ol' 
            ? this.renderOrderedList()
            : this.renderUnorderedList()
        }
        {data.postText}
      </Typography>
    );
  }
}